module.exports = __webpack_public_path__ + "assets/img/Edito_Bertrand-Cozzarolo_cover.ff142ac2-ps.jpg";